import { useI18n } from '../i18n';

/**
 * Attribution for the work behind the tool.
 *
 * Only rendered in the scrolling shell. The map view (`app--full`) hands the
 * canvas every pixel below the header, so a footer there would either steal
 * height from the map or sit outside the viewport where nobody sees it.
 */
export function AppFooter() {
  const { t } = useI18n();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <p className="footer__line footer__line--institution">{t('footer.institution')}</p>
        <p className="footer__line">{t('footer.advisor')}</p>
        <p className="footer__line">{t('footer.author')}</p>
      </div>
    </footer>
  );
}
